import { render, staticRenderFns } from "./TicketReportbyagent.vue?vue&type=template&id=b2b06692&"
import script from "./TicketReportbyagent.vue?vue&type=script&lang=js&"
export * from "./TicketReportbyagent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports